import React from 'react'
import { GoArrowDownRight } from 'react-icons/go'

export default function RevenueShareModel() {
  return (
    <div
      class='w-full relative '
      id='nft'
    >
      <section class='w-full bg_elips left-0  py-10 relative px-5 flex flex-col justify-center items-center gap-4'>
        <div className='box px-8 font-medium py-1.5 rounded-full text-[#DBA200] text-xl  animate__zoomInUp animate__animated wow'>
          Revenue Share
        </div>
        <h1 className='text-5xl animate__slideInUp animate__animated wow text-center'>
          Revenue Share Model
        </h1>
        <a
          href=''
          className='border-2 animate__slideInDown animate__animated wow flex items-center gap-1 group border-[#D2A42C] bg-black md:py-3 py-2 md:px-10 px-5  md:text-2xl text-xl rounded-2xl transition ease-in-out delay-150  hover:-translate-y-1 hover:scale-105  duration-300'
        >
          Revenue Dapp
          <GoArrowDownRight className='group-hover:translate-x-4 transition ease-in-out delay-150 duration-300' />
        </a>
      </section>
      <div class=' text-white flex justify-center items-center min-h-screen z-10 relative md:-translate-x-20'>
        <div class='container mx-auto p-4'>
          <div class='flex flex-wrap justify-center items-start relative'>
            <div class='w-full md:w-1/4 p-4 flex flex-col items-start '>
              <div class='box2 animate__zoomIn wow animate__animated py-10 px-4 md:mb-4 mb-8 border_1 rounded-2xl text-center w-full'>
                <div class=' md:text-2xl text-xl font-bold mb-2'>
                  AI Copytrader Bot
                </div>
                <div>50% of Trade Fees</div>
              </div>

              <div class='box2 animate__zoomIn wow animate__animated py-10 px-4 md:mb-4 mb-8 border_1 rounded-2xl text-center w-full'>
                <div class=' md:text-2xl text-xl font-bold mb-2'>
                  Buy & Sell Fees
                </div>
                <div>1% of Tax Fees</div>
              </div>
              <div class='box2 animate__zoomIn wow animate__animated py-10 px-4 md:mb-4 mb-8 border_1 rounded-2xl text-center w-full'>
                <div class=' md:text-2xl text-xl font-bold mb-2'>
                  Team Trading Earnings
                </div>
                <div>15% of Profits</div>
              </div>
              <div class='box2 animate__zoomIn wow animate__animated py-10 px-4 md:mb-4 mb-8 border_1 rounded-2xl text-center w-full'>
                <div class=' md:text-2xl text-xl font-bold mb-2'>
                  Bot Adverts
                </div>
                <div>15% of Profits</div>
              </div>
              <div class='box2 animate__zoomIn wow animate__animated py-10 px-4 md:mb-4 mb-3 border_1 rounded-2xl text-center w-full'>
                <div class=' md:text-2xl text-xl font-bold mb-2'>
                  Premium Bot
                </div>
                <div>15% of Profits</div>
              </div>
            </div>

            <div class='w-full md:w-1/4 flex flex-col items-center'>
              <div class='revanu md:w-auto w-full flex items-center justify-center  lg:h-[900px] md:h-[600px] h-[500px] rounded-lg  text-center md:mt-2 mt-1'>
                <div class='md:text-4xl text-6xl text-nowrap font-bold mb-2 -rotate-90 '>
                  Revenue Pool
                </div>
              </div>
            </div>

            <div class='w-full md:w-1/4 p-4 flex flex-col items-start md:mt-0 mt-4 relative'>
              <div class='box3 relative animate__zoomIn wow animate__animated py-10 px-4 md:mb-4 mb-8 border_1 rounded-2xl text-center w-full'>
                <div class=' md:text-2xl text-xl font-bold mb-2'>Eth Claim</div>
                <div>4% Tax</div>
              </div>
              <div class='box3 relative animate__zoomIn wow animate__animated py-10 px-4 md:mb-4 mb-8 border_1 rounded-2xl text-center w-full'>
                <div class=' md:text-2xl text-xl font-bold mb-2'>
                  0.1% + HOLDER
                </div>
                <div>Share of Revenue</div>
              </div>
              <div class='box3 relative  animate__zoomIn wow animate__animated py-10 px-4 md:mb-4 mb-8 border_1 rounded-2xl text-center w-full'>
                <div class=' md:text-2xl text-xl font-bold mb-2'>
                  $DEEPAI Claim
                </div>
                <div>0% Tax</div>
              </div>
              <div class='box3 relative animate__zoomIn wow animate__animated py-10 px-4 md:mb-4 mb-8 border_1 rounded-2xl text-center w-full'>
                <div class=' md:text-2xl text-xl font-bold mb-2'>
                  Accumulate $DEEPAI
                </div>
                <div>for Higher Rev Share</div>
              </div>
              <div class='box3 relative md:hidden block  animate__zoomIn wow animate__animated py-10 px-4 md:mb-4 mb-8 border_1 rounded-2xl text-center w-full'>
                <div class=' md:text-2xl text-xl font-bold mb-2'>
                  SELL $DEEPAI
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class='box4 md:absolute md:block hidden -translate-x-[2.5%] -translate-y-[33%] right-[2.5%] max-w-[250px] bottom-[33%]  animate__zoomIn wow animate__animated py-10 px-4 md:mb-4 mb-8 border_1 rounded-2xl text-center w-full'>
        <div class=' md:text-2xl text-xl font-bold mb-2'>SELL $DEEPAI</div>
      </div>
    </div>
  )
}
